export default __webpack_public_path__ + "static/media/token-utility-mobile.0a9ba64a.png";